/**
 * @generated SignedSource<<8e687db6db3c7a18761a3b83bcccad09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfirmSuggestionInputObject = {
  categoryId?: string | null | undefined;
  stakeholderId?: string | null | undefined;
  suggestionId: string;
};
export type reviewPage_ConfirmSuggestionMutation$variables = {
  input: ConfirmSuggestionInputObject;
};
export type reviewPage_ConfirmSuggestionMutation$data = {
  readonly confirmSuggestion: {
    readonly coverage: {
      readonly categorizedTxnsCount: number;
      readonly totalTxnsCount: number;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type reviewPage_ConfirmSuggestionMutation = {
  response: reviewPage_ConfirmSuggestionMutation$data;
  variables: reviewPage_ConfirmSuggestionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categorizedTxnsCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTxnsCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "reviewPage_ConfirmSuggestionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ConfirmSuggestionMutationPayload",
        "kind": "LinkedField",
        "name": "confirmSuggestion",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CategorizationCoverage",
            "kind": "LinkedField",
            "name": "coverage",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "reviewPage_ConfirmSuggestionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ConfirmSuggestionMutationPayload",
        "kind": "LinkedField",
        "name": "confirmSuggestion",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CategorizationCoverage",
            "kind": "LinkedField",
            "name": "coverage",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a249bf17a1b9201956264d74f5350614",
    "id": null,
    "metadata": {},
    "name": "reviewPage_ConfirmSuggestionMutation",
    "operationKind": "mutation",
    "text": "mutation reviewPage_ConfirmSuggestionMutation(\n  $input: ConfirmSuggestionInputObject!\n) {\n  confirmSuggestion(input: $input) {\n    rule {\n      id\n    }\n    coverage {\n      categorizedTxnsCount\n      totalTxnsCount\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d6213c1d3862ec3bccc08e5868087512";

export default node;
